import React from 'react';
import { ArrowUpRight, Check } from 'lucide-react';
import { solutions } from '../data/site';
import { WhatsAppLink } from './WhatsAppLink';
import { SolutionGallery } from './SolutionGallery';

export const Solutions = () => (
  <section id="solutions" className="section-space solutions-section" aria-labelledby="solutions-heading" data-testid="solutions-section">
    <div className="site-container">
      <div className="section-heading-row">
        <div><h2 className="section-kicker" id="solutions-heading">NOSSAS SOLUÇÕES</h2><p className="section-title" data-testid="solutions-title">O próximo nível<br />do seu projeto.</p></div>
        <p className="section-intro">Cada espaço tem uma necessidade.<br />Nós temos a solução para movimentá-lo.</p>
      </div>
      <div className="solutions-grid">
        {solutions.map(solution => (
          <section className="solution-card" id={`solution-${solution.id}`} aria-labelledby={`title-${solution.id}`} key={solution.id} data-testid={`solution-${solution.id}`}>
            <SolutionGallery solution={solution} />
            <div className="solution-body">
              <p className="solution-category">{solution.category}</p>
              <h3 id={`title-${solution.id}`} data-testid={`solution-title-${solution.id}`}>{solution.title}</h3>
              <p className="solution-description" data-testid={`solution-description-${solution.id}`}>{solution.description}</p>
              <ul data-testid={`solution-benefits-${solution.id}`}>{solution.benefits.map(benefit => <li key={benefit}><Check size={15} aria-hidden="true" /><span>{benefit}</span></li>)}</ul>
              <WhatsAppLink subject={solution.title.toLocaleLowerCase('pt-BR')} className="solution-quote" testId={`quote-${solution.id}`} aria-label={`Solicitar orçamento: ${solution.title}`}>Solicitar orçamento <ArrowUpRight size={19} /></WhatsAppLink>
            </div>
          </section>
        ))}
      </div>
      <p className="photo-disclaimer" data-testid="solutions-project-note">Características e capacidades são definidas conforme cada projeto.</p>
    </div>
  </section>
);